import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { Datapoints } from '../datapoints';
import LinkedEntity from '../store/schema/LinkedEntity';

export const setSubject = action('setSubject', (subject: string) => ({
    subject,
}));

export const setIsShown = action('setIsShown', (isShown: boolean) => ({
    isShown,
}));

export const setFolderId = action('setFolderId', (folderId: string) => ({
    folderId,
}));

export const setIsFocused = action('setIsFocused', (isFocused: boolean) => ({
    isFocused,
}));

export const setLinkedEmailEntity = action(
    'setLinkedEmailEntity',
    (linkedEmailEntity: LinkedEntity) => ({
        linkedEmailEntity,
    })
);

export const setExtractionId = action('setExtractionId', (extractionId: string) => ({
    extractionId,
}));

export const addTodo = action(
    'addTodo',
    (subject: string, folderId: string, linkedEmailEntity?: LinkedEntity, extractionId?: string) =>
        addDatapointConfig(Datapoints.todoItemActionCreate.datapoint(), {
            subject,
            folderId,
            linkedEmailEntity,
            extractionId,
        })
);
